export default __webpack_public_path__ + "static/media/menu-icon-mobile.6d920f8f.svg";